import React from 'react';

import { Stack } from '@origin-digital/ods-core';

import {
  AddressDefinition,
  DivisionDefinition,
  ContractAccountDefinition,
} from 'src/components/Definition';
import { IDivisionIdWithLpg } from 'src/consts';

interface IProps {
  divisionId: IDivisionIdWithLpg | '';
  contractAccountId: string;
  address?: string;
}

export const ContractInformation: React.SFC<IProps> = ({
  divisionId,
  contractAccountId,
  address,
}) => {
  return (
    <Stack data-id="contract-information" space="xsmall" dividers>
      <AddressDefinition address={address} />
      <DivisionDefinition divisionId={divisionId} />
      <ContractAccountDefinition
        divisionId={divisionId}
        contractAccountId={contractAccountId}
        hideBottomBorder
      />
    </Stack>
  );
};
